export default "__VITE_ASSET__sWdV2ChM__"